angular
	.module 'App.Directive'
	.directive 'wmSelectItem', ->
		restrict: 'EA'
		require: '^wmSelect'
		scope:
			item: '='
			attributesMap: '='
			itemTemplate: '@'
		## Since templateUrl is rendered before we got actual scope values and
		## template-url accepts its value as a plain text,
		## we use ng-include to load a template in a dynamic way
		template: '<ng-include src="itemTemplate"></ng-include>'
